import { useMemo } from "react";

export const useTransformedData = (formattedData, filteredMetricsConfig, opacity) => {
  return useMemo(() => {
    return Object.keys(filteredMetricsConfig).map((key) => {
      const metricsConfig = filteredMetricsConfig[key];

      const id = metricsConfig.id;
      const title = metricsConfig.name;

      const value = formattedData?.reduce((total, item) => total + (item.metrics[id] || 0), 0);
      const metricOpacity = opacity ? opacity[id] ?? 1 : 1;

      return {
        id,
        title,
        color: metricsConfig.color,
        value,
        opacity: metricOpacity
      };
    });
  }, [formattedData, filteredMetricsConfig, opacity]);
};
